import { buildSlice, InviteState } from './slice';

export * from './InviteDialog';
export * from './slice';

const inviteSlice = buildSlice((state: { invite: InviteState }) => state.invite);
export default inviteSlice;
export const selectors = inviteSlice.selectors;
